import { useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, UserCheck, Eye } from "lucide-react";

export const NextFitReactivation = ({ unitId }) => {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (apply) => {
    if (apply && !window.confirm(`Reativar ${r?.a_corrigir ?? 0} aluno(s) listados na prévia? Nenhum pagamento, venda ou caixa é alterado.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/integrations/nextfit/units/${unitId}/reactivation?apply=${apply}`);
      setR(data);
      if (apply) toast.success(`${data.corrigidos} aluno(s) regularizados`);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha"); }
    finally { setBusy(false); }
  };
  const count = r ? (r.apply ? r.corrigidos : r.a_corrigir) : 0;
  return (
    <Card className="p-5" data-testid="reactivation-card">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
        <div className="flex items-center gap-2"><UserCheck className="w-5 h-5 text-slate-700"/><h3 className="font-heading text-lg font-black text-slate-900">Reativar migrados que já compraram</h3></div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => run(false)} disabled={busy} data-testid="reactivation-preview-btn">{busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin"/> : <Eye className="w-4 h-4 mr-1"/>}Prévia</Button>
          {r && !r.apply && r.a_corrigir > 0 && <Button onClick={() => run(true)} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="reactivation-apply-btn">Aplicar ({r.a_corrigir})</Button>}
        </div>
      </div>
      <p className="text-xs text-slate-500">Lista quem tem histórico Next Fit, comprou após a migração com validade futura e continua inativo ou suspenso pela migração. Desativações e suspensões feitas no American Fit são mantidas. A prévia não grava nada.</p>
      {r && (
        <div className="mt-3 text-[11px] space-y-2" data-testid="reactivation-report">
          <div className="font-bold">{r.apply ? "Aplicado" : "Prévia (nada gravado)"} · {count} aluno(s) · {r.candidatos} inativos/suspensos migrados analisados</div>
          {Object.entries(r.ignorados || {}).map(([k, v]) => <div key={k}>Mantidos — {k}: <b>{v}</b></div>)}
          <div className="max-h-72 overflow-auto rounded border p-2">
            {r.itens.map((i) => (
              <div key={i.student_id} className="border-t py-1" data-testid="reactivation-item">
                <b>{i.aluno}</b> · validade {String(i.validade).slice(0, 10)} · venda {i.venda_em?.slice(0, 10)} R$ {i.valor.toFixed(2)} · {i.reativar ? "reativar" : ""} {i.retirar_suspensao_migracao ? "· retirar suspensão da migração" : ""} {i.suspensao_af_mantida ? "· suspensão AF mantida" : ""}
              </div>
            ))}
            {!r.itens.length && <div className="text-slate-500">Nenhum aluno a regularizar.</div>}
          </div>
        </div>
      )}
    </Card>
  );
};
